export default __webpack_public_path__ + "static/media/modal-icon-game-result-1.5GB.e725c17b.svg";